//
// Copyright (c) 2017 by Xolas.io. All Rights Reserved.
//

/*
Helper methods when posting stuff
----------------------------------------------------------------------- */
import axios from '@/lib/axiosClient'

import Vue from 'vue'

import VueEvents from 'vue-events'

// import MD5 from 'crypto-js/md5'

Vue.use(VueEvents)

export default {
  methods: {


    /**
     @param {String} url - the GET url.
     @param {Function} callback = null - if present will be called in success
     @param {String} text = 'information' - for messages.
     @param {Function} errorCallback = null - if present, will be called on failure of save.

     Calls fetchDataRawURL after wrapping getEndpoint(url)
     */
    async fetchData (url, callback = null, text = 'information', errorCallback = null) {
      return this.fetchDataRawURL(this.getEndpoint(url), callback, text, errorCallback)
    },



    /**
     @param {String} url - the GET raw url.
     @param {Function} callback = null - if present will be called in success
     @param {String} text = 'information' - for messages.
     @param {Function} errorCallback = null - if present, will be called on failure of save.
     */
    async fetchDataRawURL (url, callback = null, text = 'information', errorCallback = null) {

      axios.get(url)
        .then(response => {

          let data = response.data

          if (!this.checkWarning(response)) {
            if (response.data && response.data.data) {
              data = response.data.data
            }
          }

          if (this.isFunction(callback)) {
            callback(data)
          }

          return data

        })
        .catch(err => {
          if (err.response && err.response.status && err.response.status === 401) {
            this.logout()
          }

          console.error('fetchDataRawURL failed [', text, ']', url, 'message:', err)

          if (this.isFunction(errorCallback)) {
            errorCallback(err)
          }

          this.$notify(
            {
              title: 'Unable to fetch ' + text,
              message: err,
              type: 'error',
              duration: 3000
            })
        })
    },




    /**
     @param {this} self - for messages and alerts.
     @param {Number} id - if null will create, else save.
     @param {String} url - the POST/PUT url.
     @param {Object} formData - data to be saved.
     @param {String} item for messages, etc.
     @param {Function} successCallback - if present will be called in success
     @param {Function} failCallback - if present, will be called on failure of save.
     @param {Boolean} showMessage = true, if false then no messages will be shown.
     @param {String/Array} tableRef refreshes table, or multiple tables, if array of string.

     Original saveForm, the tableRef param is a later addition, not break existing code.
     */
    async saveForm (self, url, id, formData, item = 'item', successCallback, failCallback, showMessage = true, tableRef = null) {

      if (!formData.updated_by) {
        formData.updated_by = this.userName()
      }

      if (id === null) {
        formData.created_by = this.userName()
      }

      var formAction = null

      // If has a valid ID for the object, the update, else add.
      if (id) {
        formAction = axios.put
        url = this.getEndpoint(url, id)
      } else {
        formAction = axios.post
        url = this.getEndpoint(url)
      }

      return this.send(self, url, formData, item, successCallback, failCallback, formAction, showMessage, 'Save', tableRef)
    },



    /**
     @param {this} self - for messages and alerts.
     @param {String} url - the POST/PUT url.
     @param {Object} formData - data to be saved.
     @param {String} item for messages, etc.
     @param {Function} successCallback - if present will be called in success
     @param {Function} failCallback - if present, will be called on failure of save.
     @param {axios} formAction - put, post, delete, etc.
     @param {Boolean} showMessage = true, if false then no messages will be shown.
     @param {String/Array} tableRef refreshes table, or multiple tables, if array of string.

     Lower level function, for calls in PostMixins only.
     */
    async send (self, url, formData, item = 'item', successCallback = null, failCallback = null, formAction = axios.post, showMessage = false, actionType = 'Post', tableRef = null) {

      if (this.isViewOnly()) {
        self.$message({
          type: 'warning',
          title: 'View Only User',
          message: 'You are view only, can\'t save'
        })

      return

      }

      if (formAction) {
        formAction(url, formData)
        .then(response => {

          if (!this.checkWarning(response)) {

            let data = response.data

            if (response.data && response.data.length >= 1) {
              data = response.data[0]
            }

            this.eventTableRef(tableRef)

            if (successCallback && response && response.status === 200) {
              this.refreshStats()
              successCallback(data)
            }

            if (showMessage) {
              self.$message({
                type: 'success',
                title: 'Success',
                message: '[' + item + '] updated'
              })
            }

            return data

          }

          return null
        })
        .catch(err => {


          if (err.response) {
            console.error(actionType, err)

            let data = err.response.data

            if (err.response.status === 401) {
              this.logout()
            }


            // Status: 418 I'm a teapot - Used by Telco errors
            if (data && data.status && data.status === 418) {
              self.$notify({
                title: 'Problem',
                message: 'Unable to ' + actionType.toLowerCase() + ' ' + item + ' [' + err.response.data.error + ']',
                type: 'error',
                duration: 5500
              })

              return
            }

            if (data && data.error) {
              self.$notify({
                title: 'Problem',
                message: data.error,
                type: 'error',
                duration: 5500
              })

              return
            }


            if (data && data.warning) {
              self.$notify({
                title: 'Warning',
                message: data.warning,
                type: 'warning',
                duration: 5500
              })

              return
            }


            if (data && data.errors) {

              let errors = data.errors
              let i = 0
              let len = 0


              // count props..
              for (const p in errors) {
                console.warn(`${p}`, errors[p][0])
                len++
              }


              for (const prop in errors) {

                self.$notify({
                  title: 'Problems [' + (i + 1) + ' of ' + len + ']',
                  message: errors[prop][0],
                  type: 'warning',
                  duration: 5500
                })

                if (failCallback) {
                  failCallback(err.response.errors)
                }

                i++

              }  // for


            } else {

              self.$notify({
                title: 'Problems',
                message: 'Unable to ' + actionType.toLowerCase() + ' ' + item + ' [' + err.status + '] ' + (err.response.data ? err.response.data : err.response.message),
                type: 'error',
                duration: 5500
              })

            }

          } // if err.reponse

        })  // catch
      }
    },  // send




    /**
     @param {String/Array} tableRef refreshes table, or multiple tables, if array of string.

     Fires refresh for each tableRef.
     */
    eventTableRef (tableRef) {

      let tr = '-refresh-table'

      if (tableRef) {
        if (this.isString(tableRef)) {
          this.$events.fire(tableRef + tr)

        } else if (this.isArray(tableRef)) {
          for (var i = 0; i < tableRef.length; i++) {
            this.$events.fire(tableRef[i] + tr)
          }
        }
      }

    },




    /**
     @param {String} sUrl - download URL
     @param {String} fileName = null, for download

     @return {Boolean} true if successful, else false

     The downloadFile code is from: https://github.com/PixelsCommander/Download-File-JS
     (C) Copyright 2013 Denis Radin. Apache License terms.
      Modified to ES6 standards.
      */
    downloadFile (sUrl, fileName = null) {

      // iOS devices do not support downloading. We have to inform user about this.
      if (/(iP)/g.test(navigator.userAgent)) {
        alert('Your device does not support files downloading. Please try again in desktop browser.')
        return false
      }

      // If in Chrome or Safari - download via virtual link click
      if (this.getStore().isChrome || this.getStore().isSafari) {
        // Creating new link node.
        var link = document.createElement('a')

        link.target = '_blank'
        link.href = sUrl

        if (link.download !== undefined) {
          // Set HTML5 download attribute. This will prevent file from opening if supported.
          fileName = fileName ? fileName : sUrl.substring(sUrl.lastIndexOf('/') + 1, sUrl.length)
          link.download = fileName
        }

        // Dispatching click event.
        if (document.createEvent) {
          var e = document.createEvent('MouseEvents')
          e.initEvent('click', true, true)
          link.dispatchEvent(e)
          return true
        }
      }

      // Force file download (whether supported by server).
      if (sUrl.indexOf('?') === -1) {
        sUrl += '?download'
      }

      window.open(sUrl, '_self')
      return true
    },



    /**
     @param {Object} data - file data to download.
     @param {String} fileName for messages, etc.
     @param {String} type default: 'application/octet-stream'

     download data via dynamic link.
     */
    download (data, filename, type = 'application/octet-stream') {
      var file = new Blob([data], {type: type})
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(file, filename)  // IE10+
      } else { // Others
        var a = document.createElement('a'),
          url = URL.createObjectURL(file)
        a.href = url
        a.download = filename
        document.body.appendChild(a)
        a.click()
        setTimeout(function () {
          document.body.removeChild(a)
          window.URL.revokeObjectURL(url)
        }, 0)
      }
    },




    /**

     @param {this} self - for messages and alerts.
     @param {Number} id - the ID of the record to delete.
     @param {String} url - the POST/PUT url.
     @param {String} message - Message to display in the confirm dialog.
     @param {Function} callback - if present will be called with what ever the server responds with.
     @param {String/Array} tableRef refreshes table, or multiple tables, if array of string.

     If confirm = true pops up a confirm dialog with contents for 'message'
     */
    async deleteItem (self, id, url, message, callback, confirm = true, tableRef = null, confirmYesText = 'Yes') {

      if (this.isViewOnly()) {
        self.$message({
          type: 'warning',
          title: 'View Only User',
          message: 'You are view only, can\'t delete'
        })

      return

      }


      url = this.getEndpoint(url, id)

      if (confirm) {
        self.$confirm('This will permanently delete <b>' + message + '</b> Continue?', 'Warning', {
          confirmButtonText: confirmYesText,
          cancelButtonText: 'No',
          center: true,
          dangerouslyUseHTMLString: true,
          type: 'error'
        }).then(() => {
          return this.deleteRaw(self, url, id, message, callback, true, tableRef)
        }).catch(() => {
          self.$message({
            type: 'info',
            message: 'Delete cancelled'
          })
        })
      } else {
        return this.deleteRaw(self, url, id, message, callback, false, tableRef)
      }

      return null
    },   // deleteItem



    /**

     @param {this} self - for messages and alerts.
     @param {Number} id - the ID of the record to delete.
     @param {String} url - the POST/PUT url.
     @param {String} message - Message to display in the confirm dialog.
     @param {Function} callback - if present will be called with what ever the server responds with.
     @param {String/Array} tableRef refreshes table, or multiple tables, if array of string.

     Without wrapping getEndpoint(url).
     */
    async deleteRaw (self, url, id, message, callback, showMsgs = true, tableRef = null) {
      axios.delete(url, id)
      .then(response => {
        if (!this.checkWarning(response, showMsgs)) {

          this.refreshStats()

          if (showMsgs) {
            self.$message({type: 'success', message: 'Delete [' + message + '] completed'})
          }

          let data = response.data[0]

          this.eventTableRef(tableRef)

          if (callback) {
            callback(data)
          }

          return data
        }

      })
      .catch(err => {
        self.$notify({
          type: 'error',
          message: 'Delete failed ' + err.message
        })
      })  // catch
    },    // deleteRaw




    /**

     @param {this} self - for messages and alerts.
     @param {String} url - the POST/PUT url.
     @param {String} message - Message to display in the confirm dialog.
     @param {Function} callback - if present will be called with what ever the server responds with.

     Without ID, your URL must contain valid delete clauses.
     */
    async delete (self, url, message, callback) {
      url = this.getEndpoint(url)

      self.$confirm('This will permanently delete <b>' + message + '</b> Continue?', 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        center: true,
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(() => {

        axios.delete(url)
        .then(response => {

          if (callback) {
            callback(response)
          }

          if (!this.checkWarning(response)) {

            this.refreshStats()

            self.$message({
              type: 'success',
              message: 'Delete [' + message + '] completed'
            })

          }

          return response
        })
        .catch(err => {
          self.$notify({
            type: 'error',
            message: 'Delete failed ' + err.message
          })
        })  // catch
      }).catch(() => {
        self.$message({
          type: 'info',
          message: 'Delete cancelled'
        })
      })
    }   // delete

  }
}



// WEBPACK FOOTER //
// ./src/mixins/PostMixins.js